import axios from 'axios';

const AffiliatePanelInstance = axios.create({
    baseURL: process.env.REACT_APP_ADMIN_PANEL_BACKEND_BASE_URL
});

export default AffiliatePanelInstance;